// extracted by mini-css-extract-plugin
module.exports = {"closer":"close-button_closer__1VBo7"};